import Vue from 'vue';
import noty from './noty.service';

export default {
  async getByClient() {
    return (await Vue.http.get('/api/branches')).data;
  },
  async get(branch) {
    return (await Vue.http.get(`/api/branches/${branch}`)).data;
  },
  async create(branch) {
    let b = (await Vue.http.post('/api/branches/create', branch)).data;
    noty.success(`Branch '${b.branch}' created successfully`);
    return b;
  },
  async update(branch) {
    let b = (await Vue.http.post('/api/branches/update', branch)).data;
    noty.success(`Branch '${b.branch}' updated successfully`);
    return b;
  },
  async getPages(branch) {
    return (await Vue.http.get(`/api/branches/${branch}/pages`)).data;
  },
  async getPage(branch, pageName, pageLanguage) {
    return (await Vue.http.get(`/api/branches/${branch}/pages/get/${pageName}/${pageLanguage}`)).data;
  },
  async createPage(branch, page) {
    let p = (await Vue.http.post(`/api/branches/${branch}/pages/create`, page)).data;
    noty.success(`Page '${p.name}' created successfully`);
    return p;
  },
  async updatePage(branch, page) {
    let p = (await Vue.http.post(`/api/branches/${branch}/pages/update`, page)).data;
    noty.success(`Page '${p.name}' updated successfully`);
    return p;
  },
  async deletePage(branch, pageName, pageLanguage) {
    let p = (await Vue.http.delete(`/api/branches/${branch}/pages/delete/${pageName}/${pageLanguage}`)).data;
    noty.success(`Page '${pageName}' deleted successfully`);
    return p;
  },
  async saveSettings(branch, settings) {
    let s = (await Vue.http.post(`/api/branches/${branch}/settings`, settings)).data;
    noty.success(`Settings for branch '${branch}' saved successfully`);
    return s;
  }
}



// WEBPACK FOOTER //
// ./src/services/branch.service.js